export default "__VITE_ASSET__0XZwgnzA__"